import { render, staticRenderFns } from "./myattendPc.vue?vue&type=template&id=490b1a30&scoped=true&"
import script from "./myattendPc.vue?vue&type=script&lang=js&"
export * from "./myattendPc.vue?vue&type=script&lang=js&"
import style0 from "./myattendPc.vue?vue&type=style&index=0&id=490b1a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b1a30",
  null
  
)

export default component.exports